"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.viewOptions = exports.breakdownOptions = void 0;
// ── Constants ──
exports.breakdownOptions = [
    { label: 'Category', value: 'category', id: 'itemized_breakdown_category' },
    { label: 'Payee', value: 'payee', id: 'itemized_breakdown_payee' },
];
exports.viewOptions = [
    { label: 'Top-level Summary', value: 'top', id: 'itemized_view_top' },
    { label: 'Category Summary', value: 'category', id: 'itemized_view_category' },
    { label: 'Transaction Detail', value: 'transactions', id: 'itemized_view_transactions' },
];
